import { render, staticRenderFns } from "./UserAvatarController.vue?vue&type=template&id=ec70ceee&"
import script from "./UserAvatarController.vue?vue&type=script&lang=ts&"
export * from "./UserAvatarController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports